module.exports = __webpack_public_path__ + "static/media/k12_site_sell_header.f664d17f.jpg";